import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dummyData from "../../database/programs.json";
import adapter from "./adapter";
import * as config from "./config";
import { generateCoreExtraReducers, generateSliceCore } from "../core/tools";
import apiService from "../api/service";
import filter from "./filter";
import { getCoordinateObject } from "../../utils";
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: dummyData,
    data_options: [],
    data_map: [],
    data_map_nested: [],
    data_featured: [],
    status_featured: "idle",
    data_upcoming: [],
    data_past: [],
    data_ongoing: [],
    data_ongoing_map: [],
    data_completed: [],
    data_completed_map: [],
    data_by_location: {},
    data_statistic: {}
  },
  action: {
    fetchPrograms: createAsyncThunk(
      `${NAME}/fetchPrograms`,
      async (options) => {
        const data = await apiService.get(NAME, options);
        return data;
      }
    ),
    fetchFeaturedPrograms: createAsyncThunk(
      `${NAME}/fetchFeaturedPrograms`,
      async (options) => {
        const data = await apiService.get("programs_featured", options);
        return data;
      }
    ),
    fetchProgramsStatistic: createAsyncThunk(`${NAME}/fetchProgramsStatistic`, async (options) => {
      const data = await apiService.getStatistic(NAME, options);
      return data;
    }),
  },
};

/** Action - Thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action;
export const { fetchPrograms, fetchFeaturedPrograms, fetchProgramsStatistic } = app.action;

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

/** Slice */
export const programsSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState,
  },
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
    setStatusPrograms(state, action) {
      state.programs_status = action.payload;
    },
    setPageItems(state, action) {
      state.pageItems = action.payload;
    },
  },
  extraReducers: {
    ...coreExtraReducers,

    [fetchPrograms.pending]: (state) => {
      state.status = "loading";
    },
    [fetchPrograms.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const { results, count } = action.payload;

      const withLocationOnly = results.filter(r => r.lokasi && r.lokasi.length > 0)
      const filtered = []

      if(withLocationOnly && withLocationOnly.length > 0){
        for (let index = 0; index < withLocationOnly.length; index++) {
          const program = results[index];
          const locations = program.lokasi

          if(locations && locations.length > 0){
            for (let index1 = 0; index1 < locations.length; index1++) {
              const location = locations[index1];
              const coordinateString = location.pinLocation
              const coordinateObject = getCoordinateObject(coordinateString)
              if(coordinateObject){
                filtered.push(program)
              }
            }
          }
        }
      }

      const data = adapter.responseBodyToRender(results)
      state.data = data;
      state.pageItems = data;
      state.data_options = adapter.responseBodyToOptions(results);
      state.data_upcoming = filter.upcoming(data);
      state.totalItems = count;

      state.data_ongoing = data.filter(p => p.is_ongoing)
      state.data_ongoing_map = data.filter(p => p.is_ongoing && p.locations.length > 0)
      state.data_completed = data.filter(p => p.is_past)
      state.data_completed_map = data.filter(p => p.is_past && p.locations.length > 0)

      // Reduce by province, by status
      const byProvince = adapter.responseBodyToByProvince(filtered);
      const byProvinceByStatus = adapter.responseBodyToByProvinceByStatus(filtered);
      const data_map = adapter.responseBodyToMap(filtered, byProvince, byProvinceByStatus);
      const data_map_nested = adapter.responseBodyToNestedMap(filtered, byProvince, byProvinceByStatus);
      console.log({data_map, data_map_nested})
      state.data_map = data_map
      state.data_map_nested = data_map_nested
    },
    [fetchPrograms.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchFeaturedPrograms.pending]: (state) => {
      state.status_featured = "loading";
    },
    [fetchFeaturedPrograms.fulfilled]: (state, action) => {
      state.status_featured = "succeeded";
      state.data_featured_payload = action.payload;
      state.data_featured = adapter.responseBodyToRender(action.payload);
    },
    [fetchFeaturedPrograms.rejected]: (state, action) => {
      state.status_featured = "failed";
    },

    [fetchProgramsStatistic.fulfilled]: (state, action) => {
      const { payload } = action
      state.data_statistic = adapter.responseBodyToStatistic(payload)
    },
  },
});

export const {
  setStatus,
  setStatusPrograms,
  setPageItems,
} = programsSlice.actions;

export const programsActions = {
  ...programsSlice.actions,
  ...core.action,
  ...app.action,
};

export default programsSlice.reducer;
